import { StocksApiRemoteService } from '../../Services/api/stocks/stocks-service'
import { IShowStocksByProductPayload, IShowStocksByProductResponse } from '../../Services/api/stocks/stocks.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyStocksUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly StocksApi: StocksApiRemoteService) {}
    

  public async handle (
    data: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.StocksApi.destroy(data)

      if (response.isFailure) {
        return response
      }

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
